import { render } from "./CASIPostquestions.vue?vue&type=template&id=7473a8e9&scoped=true"
import script from "./CASIPostquestions.vue?vue&type=script&lang=js"
export * from "./CASIPostquestions.vue?vue&type=script&lang=js"

import "./CASIPostquestions.vue?vue&type=style&index=0&id=7473a8e9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7473a8e9"]])

export default __exports__